// função útil para formatar datas.
// aceita datas no formato "2025-06-20T12:11:05"
// transforma no formato "DD-MM-YYYY"
export function formatDate(rawDate) {
  if (!rawDate) return "";

  const dateObj = new Date(rawDate);

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  return `${day}-${month}-${year}`;
}

export function formatDateAndHour(rawDate) {
  if (!rawDate) return "";
  const isoString = rawDate;
  const date = new Date(isoString);

  const formatted = date.toLocaleString("pt-PT", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
  return formatted.replace(",", " |");
}
